import React, { useState, useEffect, useContext } from "react";
import { Link, NavLink, useParams, useNavigate } from "react-router-dom";
import Swal from 'sweetalert2';
import { WebAssetsContext } from "../App";
import { ToastContainer, toast , Zoom } from 'react-toastify';

const Productedit = (props) => {
  const WebAssets = useContext(WebAssetsContext);
  const api = WebAssets.apiURL;
  const navigate = useNavigate();
  const params = useParams();
  const [disabled, setDisabled] = useState(false);
  const [id, setId] = useState(params.id);
  const [name, setName] = useState("");
  const [price, setPrice] = useState('');
  const [fullname, setFullname] = useState("");
  const [qty, setQty] = useState(0);
  const [status, setStatus] = useState(null);
  const [quickbuy, setQuickbuy] = useState(null);
  const successtoast = (text = '') => {
    toast.success(text);
  };

  const errortoast = (text) => {
    toast.error(text,
      {
        autoClose: 3000,
        transition: Zoom,
        theme: "colored",
        closeOnClick: true,
        pauseOnHover: true,
      }
    );
  };
  const actvieStatus = () => {
    setStatus('1');
  }

  const inactvieStatus = () => {
    setStatus('');
  }
  const handleSubmit = async (e) => {
    e.preventDefault();
    setDisabled(true);
    try {
      let res = await fetch(api + "updateProduct", {
        method: "POST",
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          id: id,
          name: name,
          price: price,
          status: status,
          full_name: fullname,
          qty: qty,
          quickbuy: quickbuy,
        }),
      });
      let output = await res.json();
      setDisabled(false);
      if (res.status === 200) {
        if (output.status === 2) {
          getvalidationErr(output.response);
        }
        if (output.status === true) {
          Swal.fire({
            title: 'Success',
            text: 'Product updated successfully!',
            icon: 'success'
          }).then((result) => {
            if (result.isConfirmed) {
              setName(output.response.name);
              setPrice(output.response.price);
              setQty(output.response.qty);
              setFullname(output.response.full_name);
              setStatus(output.response.status);
              setQuickbuy(output.response.quick_buy);
              navigate("/admin/products");
            }
          });
        }
      }
    } catch (err) {
      setDisabled(false);
    }
  };

  const getvalidationErr = (errors) => {
    const errorsConvertInArry = Object.values(errors);
    let collectAllValidationErr = [];
    errorsConvertInArry.forEach((error, index) => {
      collectAllValidationErr.push(<div key={index}>{error}</div>);
    });
    const storeAllValidtionErr = (
      <>
        {collectAllValidationErr}
      </>
    );
    errortoast(storeAllValidtionErr);
  }



  const getProductDetails = async () => {
    const res = await fetch(api + "getProduct", {
      method: "POST",
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ id: id }),
    });
    let resJson = await res.json();
    return resJson;
  }

  const getProduct = async () => {
    try {
      const resJson = getProductDetails();
      resJson.then(function (output) {
        if (output.status === true) {
          setName(output.response.name);
          setPrice(output.response.price);
          setStatus(output.response.status);
          setQty(output.response.qty);
          setFullname(output.response.full_name);
          setQuickbuy(output.response.quick_buy);
        }
      });
    } catch (err) {
      console.log(err);
    }
  };

  useEffect(() => {
    getProduct();
  }, [id])
  return (
    <>
    <ToastContainer />
      <div className="section-body">
                <div className="row">
                  <div className="col-12">
                    <div className="card">
                      <div className="card-header">
                        <h4>Edit Commodity Product</h4>
                        <div className="card-header-form">
                          <button onClick={() => navigate("/admin/products")} className="btn btn-icon icon-left btn-primary"><i className="fas fa-arrow-right"></i> Back</button>
                        </div>
                      </div>
                      <div className="card-body p-4">

                        <form onSubmit={handleSubmit}>
                          <div className="row">
                            <div className="col-sm-6">
                              <div className="form-group">
                                <label>Product Name<small className="text-danger">*</small></label>
                                <input
                                  type="text"
                                  value={name}
                                  placeholder="Name"
                                  onChange={(e) => setName(e.target.value)}
                                  className="form-control"
                                />
                              </div>
                            </div>

                            <div className="col-sm-6">
                              <div className="form-group">
                                <label>Product Full Name <small className="text-danger">*</small></label>
                                <input
                                  type="text"
                                  value={fullname}
                                  placeholder="Full Name"
                                  onChange={(e) => setFullname(e.target.value)}
                                  className="form-control"
                                />

                              </div>

                            </div>
                            <div className="col-sm-6">
                              <div className="form-group">
                                <label>Qty</label>
                                <input
                                  type="text"
                                  value={qty}
                                  placeholder="Qty"
                                  onChange={(e) => setQty(e.target.value)}
                                  className="form-control"
                                />
                              </div>
                            </div>
                            <div className="col-sm-6">
                              <div className="form-group">
                                <label>Price<small className="text-danger">*</small></label>
                                <input
                                  type="text"
                                  value={price}
                                  placeholder="Price"
                                  onChange={(e) => setPrice(e.target.value)}
                                  className="form-control"
                                />
                              </div>
                            </div>

                            <div className="col-sm-6">
                              <div className="form-group">
                                <label>Quick Buy</label>
                                <div className="row">
                                  <div className="col-sm-3">
                                    <input type="radio" id="quickbuyyes" name="quickbuy" className=""
                                      value="YES"
                                      checked={quickbuy === 'YES'}
                                      onChange={() => setQuickbuy('YES')}

                                    /> <label htmlFor="quickbuyyes">Yes</label>
                                  </div>
                                  <div className="col-sm-3">
                                    <input type="radio" id="quickbuyno" name="quickbuy" className="custom-control-inpu"
                                      value="NO"
                                      checked={quickbuy === 'NO'}
                                      onChange={() => setQuickbuy('NO')}
                                    /> <label htmlFor="quickbuyno">No</label>
                                  </div>
                                </div>
                              </div>
                            </div>

                            <div className="col-sm-6">
                              <div className="form-group">
                                <label>Status</label>
                                <div className="row">
                                  <div className="col-sm-3">
                                    <input type="radio" id="statusActive" name="status" className=""
                                      value="1"
                                      checked={status === '1'}
                                      onChange={actvieStatus}

                                    /> <label htmlFor="statusActive">Active</label>
                                  </div>
                                  <div className="col-sm-3">
                                    <input type="radio" id="statusInactive" name="status" className="custom-control-inpu"
                                      value="0"
                                      checked={status === ''}
                                      onChange={inactvieStatus}
                                    /> <label htmlFor="statusInactive">Inactive</label>
                                  </div>
                                </div>
                              </div>
                            </div>



                            <div className="col-12">
                              <div className="card-footer text-center">
                                <button className="btn btn-primary mr-1" type="submit" disabled={disabled}>{disabled == false ? 'Submit' : 'Submiting...'}</button>

                              </div>
                            </div>
                          </div>
                        </form>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
    </>

  );
}

export default Productedit;
